import { render, staticRenderFns } from "./DashboardMobileAppBar.vue?vue&type=template&id=63623dd5"
import script from "./DashboardMobileAppBar.vue?vue&type=script&lang=ts"
export * from "./DashboardMobileAppBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports